import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=70c19f9c&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&id=70c19f9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports